import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../../../../../services/login/login.service';
import { UtilService } from '../../../../../../services/util.service';
import { DataAddCart, ProductData } from '../../../../../../core/model/Product.model';
import { EncryptPipe } from '../../utils/pipes/encrypt.pipe';
import { ProductoService } from '../../utils/services/producto.service';

@Component({
  selector: 'app-item-producto',
  templateUrl: './item-producto.component.html',
  styleUrls: ['./item-producto.component.scss']
})
export class ItemProductoComponent implements OnInit {
  @Input() producto: any;
  currentImgIndex: number = 0; // Indica la imagen que se está intentando mostrar
  defaultImg: string = '../../../../../../assets/not_found_image.png';
  public cantidadSucursalAux: number = 0;
  public cantidadCedisAux: number = 0;
  public listCedis: ProductData;
  public listSucursal: ProductData;
  public body = document.querySelector('body');
  public mostrarIndicador: boolean;
  public text: string = "";

  constructor(
    //private productoService: ProductoService,
    private loginService: LoginService,
    public dialog: MatDialog,
    private router: Router,
    private encrypt: EncryptPipe,
    private utilService: UtilService,
    private route: ActivatedRoute,
    private productoService: ProductoService
  ) { }

  ngOnInit(): void {
    console.log(this.producto);
  }

  getCantidad(event, articulo: ProductData): void {
    console.log('event', event, 'articulo', articulo);
    if (event.cantidad > 0) {
      if (!event.cedis) {
        this.cantidadSucursalAux = event.cantidad;
        this.listSucursal = articulo;
      } else if (event.cedis) {
        this.cantidadCedisAux = event.cantidad;
        this.listCedis = articulo;
      }
    }
  }

  //Funcion que añade al carrito sin loguearme
  public addToCart = (articulo: ProductData) => {

    console.log('is listSucursal', this.listSucursal);
    console.log('is listCedis', this.listCedis);
    console.log('****', this.listSucursal !== undefined || this.listCedis !== undefined, '******');
    console.log('articulo: ', articulo);

    if (this.listSucursal !== undefined || this.listCedis !== undefined) {
      if (this.cantidadSucursalAux > 0 && this.listSucursal === articulo) {
        this.addToWishlist(articulo, this.cantidadSucursalAux, false, false);
        // this.cantidadSucursalAux = 0;
        // this.listSucursal = null;
      }
      if (this.cantidadCedisAux > 0 && this.listCedis === articulo) {
        //  console.log('Is cedis',producto, this.cantidadSucursalAux, true,false);
        this.addToWishlist(articulo, this.cantidadCedisAux, true, false);
        // this.cantidadCedisAux = 0;
        // this.listCedis = null;
      }
    } else {
      this.mostrarIndicador = true;
    }
  }

  //IsCedos = es CDMX, Todo lo que no esta en mi almacen asignado.
  public addToWishlist(articulo: ProductData, cantidad: number, isCedis: boolean, insInvitado: boolean): void {
    const existencias = isCedis ? articulo.ExistenciasCedis : articulo.ExistenciasSucursal;
    if (cantidad <= Number(existencias)) {
      const dataArticulo: DataAddCart = {
        ClaveArticulo: articulo.ClaveArticuloProveedor,
        Cantidad: cantidad,
        AlmacenID: articulo.AlmacenID,
        isCedis
      };
      if (insInvitado) {
        this.productoService.addToCartInvitado(dataArticulo, articulo);
      } else {
        // console.log('data articulo------', articulo);
        this.productoService.addToCart(dataArticulo, articulo);
      }
    }
  }

  public validDate = (fechaFin: Date) => {
    const today = new Date();
    const fin = new Date(fechaFin);
    return fin >= today;
  };

  get currentImg(): string {
    return this.producto.Img_list[this.currentImgIndex] || this.defaultImg;
  }

  handleImgError() {
    if (this.currentImgIndex < this.producto.Img_list.length - 1) {
      this.currentImgIndex++; // Intenta la siguiente imagen
    } else {
      // Si ninguna imagen es válida, muestra la imagen por defecto
      this.currentImgIndex = -1;
    }
  }

}
